import { ExcelProcessorConfig, HeaderConfig, ParsedExcelData } from '@/lib/excel';

const HEADERS = {
  MA_TT: 'Mã thanh toán*',
  TEN_TT: 'Tên thanh toán*',
  TEN_TT2: 'Tên khác',
  HAN_TT: 'Hạn thanh toán'
};

const HEADER_CONFIG: HeaderConfig[] = [
  { header: HEADERS.MA_TT, key: 'ma_tt', type: 'main' },
  { header: HEADERS.TEN_TT, key: 'ten_tt', type: 'main' },
  { header: HEADERS.TEN_TT2, key: 'ten_tt2', type: 'main' },
  { header: HEADERS.HAN_TT, key: 'han_tt', type: 'main' }
];

const parseNum = (val: unknown, def = 0) => {
  if (val == null || String(val).trim() === '') return def;
  const n = parseFloat(String(val));
  return Number.isNaN(n) ? def : Math.round(n);
};

const TransformToBodies = (
  dataRows: unknown[][],
  parsedData: ParsedExcelData,
  _uuidResponse: unknown,
  _context: unknown
): ImportBody[] => {
  const { main = {} } = parsedData;
  const bodies: ImportBody[] = [];

  for (let i = 0; i < dataRows.length; i++) {
    const ma_tt = main.ma_tt?.[i]?.toString().trim() || '';
    const ten_tt = main.ten_tt?.[i]?.toString().trim() || '';
    const ten_tt2 = main.ten_tt2?.[i]?.toString().trim() || '';
    const han_tt = parseNum(main.han_tt?.[i], 0);

    // Skip rows without required fields
    if (!ma_tt || !ten_tt) {
      continue;
    }

    bodies.push({
      ma_tt,
      ten_tt,
      ten_tt2,
      han_tt,
      status: '1'
    });
  }

  return bodies;
};

export interface ImportBody {
  ma_tt: string;
  ten_tt: string;
  ten_tt2: string;
  han_tt: number;
  status: string;
}

export const ExcelConfig: ExcelProcessorConfig<ImportBody> = {
  Headers: HEADERS,
  HeaderConfig: HEADER_CONFIG,
  RequiredFields: [
    { key: 'ma_tt', type: 'main', label: 'Mã thanh toán' },
    { key: 'ten_tt', type: 'main', label: 'Tên thanh toán' }
  ],
  Transform: TransformToBodies
};
